
const Year = (props: any) : JSX.Element => {
  return (
    <div>Year</div>
  )
}

export default Year